import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DirectionsOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"directions_off"}/>
}
